module.exports = __webpack_public_path__ + "img/tixel.60671c7a.svg";